/**
 * AIO-82875 - desktop copy of `isStandaloneDisplay()` from the mobile twin
 * (`projects/mobile/src/app/shared/utils/pwa-display-mode.util.ts`), so an installed desktop app
 * saves its push token as standalone. Browser-only: it touches `window`, so the caller guards.
 */
export function isStandaloneDisplay(): boolean {
  /* `navigator.standalone` is an iOS-only legacy flag and is not in the DOM typings, but it is
     still the only reliable signal on older Safari, which does not report display-mode. */
  return window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as any).standalone === true;
}

/**
 * AIO-82875 - can this browser show the notification permission prompt without a tap?
 *
 * Chromium-based browsers (Chrome, Edge, Brave, Opera, Samsung Internet) can. Firefox and Safari
 * refuse a prompt that is not made inside a click or tap, and every browser on iOS follows Safari.
 * There the app registers a device that already said yes and offers a tap for the rest.
 */
export function canAskPushWithoutTap(isIos: boolean): boolean {
  if (isIos) {
    return false;
  }

  const agent: string = navigator.userAgent;

  if (/firefox|fxios/i.test(agent)) {
    return false;
  }

  return /chrome|chromium|crios|edg|opr|samsungbrowser/i.test(agent);
}
